
import { ApiProperty } from '@nestjs/swagger'

/**
 * DTO pour la réponse de memberships utilisateur
 */
export class UserMembershipsResponseDto {
  @ApiProperty({
    description: 'IDs des établissements accessibles',
    type: [String],
    example: ['123e4567-e89b-12d3-a456-426614174000'],
  })
  establishmentIds: string[]

  @ApiProperty({
    description: 'IDs des classes accessibles',
    type: [String],
    example: ['987e6543-e21b-45d6-b789-123456789abc'],
  })
  classIds: string[]
}
